export default "__VITE_ASSET__d7479592__"